import {
  DELETE_COVID_STATEMENT_SUCCESS,
  DELETE_COVID_STATEMENT_FAILURE,
  DELETE_COVID_STATEMENT_REQUEST,
} from "../constants/MyM";
import { deleteApi } from "../../utils/apiCall";
import { apiToastError, apiToastSuccess } from "../../utils/MyMUtils";

const deleteCovidStatementSuccess = (data) => {
  return {
    type: DELETE_COVID_STATEMENT_SUCCESS,
    payload: data,
  };
};

const deleteCovidStatementFailure = (data) => {
  return {
    type: DELETE_COVID_STATEMENT_FAILURE,
    payload: data,
  };
};

export const deleteCovidStatementRequest = () => ({
  type: DELETE_COVID_STATEMENT_REQUEST,
});

export const deleteCovidStatement = (id, facilityId) => {
  return async (dispatch, getState) => {
    dispatch(deleteCovidStatementRequest());
    const { error, result } = await deleteApi(`/covid_vaccination_statement/${id}`, {
      facility_id: facilityId,
      vaccination_type_id: "4"
    });
    if (!error) {
      apiToastSuccess(result);
      return dispatch(deleteCovidStatementSuccess(result));
    } else {
      apiToastError(result);
      return dispatch(deleteCovidStatementFailure(result));
    }
  };
};